import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=97e8b316&"
import script from "./Guide.vue?vue&type=script&lang=js&"
export * from "./Guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1876123453/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e8b316')) {
      api.createRecord('97e8b316', component.options)
    } else {
      api.reload('97e8b316', component.options)
    }
    module.hot.accept("./Guide.vue?vue&type=template&id=97e8b316&", function () {
      api.rerender('97e8b316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Guide.vue"
export default component.exports